import React, { useEffect, useState } from "react";
import { Row, Col, Dropdown, Modal } from "react-bootstrap";
import Pagination from "../../Components/Pagination/Pagination";
import moment from "moment";
import { MdStar } from "react-icons/md";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useBlockUserMutation, useOrganiserListMutation } from "../../Services/api";
import { showToast } from "../../Services/tostify";
import Sort from "../../assets/image/sort-down-alt.svg";
import Dummy from "../../assets/image/user-circle.svg";
import View from "../../assets/image/view.svg";
import Spinnerr from "../../Components/Spinner/Spinner";
import Block from "../../assets/image/block.svg";
import Unblock from "../../assets/image/unblock.svg";

const ApproveOrganizerManagement = ({ apiTrigger, triggerApiCall, isNotification }) => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);
    const [orgId, setOrgId] = useState(null);
    const [error, setError] = useState(false);
    const [block, setBlock] = useState(false);
    const [status, setStatus] = useState(null);
    const [data, setData] = useState(null);
    const [searchQuery, setSearchQuery] = useState({
        page: 1,
        limit: 10,
        search: "",
        sort: {
            createdAt: -1,
        },
        status: 6,
    });

    const [page, setPage] = useState(1); // Initialize page state to start from 0
    const [totalPages, setTotalPages] = useState(1);
    const [nextPage, setNextPage] = useState(null);

    const blockClose = () => setBlock(false);
    const blockShow = () => {
        // dispatch(showToast("This feature coming soon", "INFO_TOAST"));
        setBlock(true);
    };
    //   const blockShow = () => setBlock(true);
    const [organizerList, response] = useOrganiserListMutation();
    const [userBlock, response2] = useBlockUserMutation();

    useEffect(() => {
        if (!response.isLoading && response.isSuccess) {
            setLoading(false);
            setData(response?.data.data);
            setPage(response?.data?.data?.page);
            setTotalPages(response?.data?.data?.total_pages);
            setNextPage(response?.data?.data?.next_page);
            if (response.data?.data?.notification_unread_count > 0) {
            
               isNotification(response.data?.data?.notification_unread_count);
            
            }
        } else if (response.isError && response.status === "rejected") {
            setError(true);
            setLoading(false);
        }
    }, [response]);

    useEffect(() => {
        // Fetch data when the component mounts and whenever searchQuery changes
        organizerList(searchQuery);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchQuery, apiTrigger]);

    const handleBlockUser = async () => {
        await userBlock({ user_id: orgId, status: status });
        // Close the modal after making the API call
    };
    useEffect(() => {
        if (!response2.isLoading && response2.isSuccess) {
            blockClose();
            setLoading(false); // Assuming the page should stop loading after the block API call
            organizerList(searchQuery);
            dispatch(showToast(`Organiser ${status !== 2 ? "unblocked" : "blocked"}`, "SUCCESS_TOAST"));
        } else if (response2.isError && response2.status === "rejected") {
            // Handle error if the block API call fails
            setLoading(false);
            setError(true);
            dispatch(showToast("Some error occured", "FAIL_TOAST"));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [response2]);
    return (
        <>
            {loading ? (
                <Spinnerr />
            ) : error ? (
                "some error occured"
            ) : (
                <div className="common-table-wrapper m-0">
                    <Row className="mb-4">
                        <Col md={6}>
                            <div className="flex gap-3">
                                <label className="relative block">
                                    <span className="sr-only">Search</span>
                                    <span className="absolute inset-y-0 left-0 flex items-center pl-2">
                                        <svg className="h-5 w-5 fill-slate-500" viewBox="0 0 20 20">
                                            <path
                                                fillRule="evenodd"
                                                d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                                                clipRule="evenodd"
                                            ></path>
                                        </svg>
                                    </span>
                                    <input
                                        className="placeholder:text-gray-400 block bg-gray-200 w-full border border-slate-300 rounded-xl py-2.5 pl-9 pr-3 shadow-sm focus:outline-none focus:border-sky-500 focus:ring-sky-500 focus:ring-1 sm:text-base"
                                        placeholder="Search"
                                        type="text"
                                        name="Search"
                                        value={searchQuery.search} // Bind the value of the input field to the search query
                                        onChange={(e) => setSearchQuery({ ...searchQuery, search: e.target.value, page: 1 })}
                                    />
                                </label>
                                <div className="flex items-center gap-3">
                                    <Dropdown>
                                        <Dropdown.Toggle className="bg-transparent p-0 border-0" id="dropdown-basic">
                                            <span>
                                                <img src={Sort} alt="sort" />
                                            </span>
                                        </Dropdown.Toggle>

                                        <Dropdown.Menu className="shadow border-0 rounded-xl">
                                            <Dropdown.Item
                                                onClick={() => setSearchQuery({ ...searchQuery, sort: { organizer_name: 1 }, status: 6, page: 1 })}
                                            >
                                                Sort by Organizer Name (A-Z)
                                            </Dropdown.Item>
                                            <Dropdown.Item
                                                onClick={() => setSearchQuery({ ...searchQuery, sort: { organizer_name: -1 }, status: 6, page: 1 })}
                                            >
                                                Sort by Organizer Name (Z-A)
                                            </Dropdown.Item>
                                            <Dropdown.Item
                                                onClick={() => setSearchQuery({ ...searchQuery, sort: { createdAt: 1 }, status: 6, page: 1 })}
                                            >
                                                Sort by Date (Oldest first)
                                            </Dropdown.Item>
                                            <Dropdown.Item
                                                onClick={() => setSearchQuery({ ...searchQuery, sort: { createdAt: -1 }, status: 6, page: 1 })}
                                            >
                                                Sort by Date (Newest first)
                                            </Dropdown.Item>
                                            <Dropdown.Item
                                                onClick={() => setSearchQuery({ ...searchQuery, sort: { createdAt: -1 }, status: 2, page: 1 })}
                                            >
                                                blocked Organiser
                                            </Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                    {/* <span>
                    <img src={Filter} alt="filter" />
                  </span> */}
                                </div>
                            </div>
                        </Col>
                        <Col md={6}></Col>
                    </Row>
                    <div className="table-responsive">
                        <table>
                            <thead>
                                <tr>
                                    <th>Sr.No.</th>
                                    <th>
                                        Organizer
                                        <br />
                                        Name
                                    </th>
                                    <th>
                                        Date
                                        <br />
                                        Joined
                                    </th>
                                    <th>
                                        Business
                                        <br />
                                        Email
                                    </th>
                                    <th>Location</th>
                                    <th>Ratings</th>
                                    <th>
                                        Events
                                        <br />
                                        Organized
                                    </th>
                                    <th>
                                        Total Revenue
                                        <br />
                                        Generated From It
                                    </th>
                                    <th>My Cut</th>
                                    <th>Tax</th>
                                    <th>
                                        Amount To
                                        <br />
                                        Distribute
                                    </th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data?.organizer_list.length > 0 ? (
                                    data.organizer_list.map(
                                        (
                                            {
                                                _id,
                                                organizer_name,
                                                image,
                                                createdAt,
                                                business_email,
                                                location,
                                                reviews,
                                                events_organized,
                                                total_revenue,
                                                my_cut,
                                                total_tax,
                                                amount_to_distribute,
                                                status,
                                            },
                                            i,
                                        ) => (
                                            <tr key={i}>
                                                <td>{(page - 1) * 10 + i + 1}</td>
                                                <td>
                                                    <span className="flex gap-2 items-center">
                                                        <img src={image || Dummy} width="12" height="12" className="rounded-full" alt="Dummy" />
                                                        {organizer_name}
                                                    </span>
                                                </td>
                                                <td>{moment(createdAt).format("MM/DD/YYYY")}</td>
                                                <td>{business_email}</td>
                                                <td>{location}</td>
                                                <td>
                                                    <span className="inline-flex items-center gap-1">
                                                        <MdStar className="text-amber-400 text-md" /> {reviews ? reviews.toFixed(1) : 0}
                                                    </span>
                                                </td>
                                                <td>{events_organized}</td>
                                                <td>₹{total_revenue !== null ? total_revenue.toFixed(2) : 0}</td>
                                                <td>₹{my_cut !== null ? my_cut.toFixed(2) : 0}</td>
                                                <td>₹{total_tax !== null ? total_tax.toFixed(2) : 0}</td>
                                                <td>₹{amount_to_distribute !== null ? amount_to_distribute.toFixed(2) : 0}</td>
                                                <td className="action-tab flex justify-center gap-2">
                                                    <Link className="inline-block" to={`/organizer-management/view-organizer/${_id}`}>
                                                        <img src={View} alt="" />
                                                    </Link>
                                                    <div
                                                        className="inline-block"
                                                        onClick={() => {
                                                            blockShow();
                                                            setOrgId(_id);
                                                            setStatus(status !== 8 ? 2 : 1);
                                                        }}
                                                    >
                                                        {status === 8 ? <img src={Unblock} alt="" /> : <img src={Block} alt="" />}
                                                    </div>
                                                </td>
                                            </tr>
                                        ),
                                    )
                                ) : (
                                    <td className="text-center" colSpan={13}>
                                        No Records Founds
                                    </td>
                                )}
                            </tbody>
                        </table>
                    </div>

                    {data?.organizer_list.length > 0 ? (
                        <Row className="mt-4 px-2">
                            <Col md={5}>
                                <div className="dataTables_info">
                                    {`Showing ${Math.min((page - 1) * 10 + 1, data?.total)}` +
                                        ` to ${Math.min(page * 10, data?.total) || 0} of ${data?.total || 0} entries`}
                                </div>
                            </Col>
                            <Col md={7}>
                                <Pagination
                                    total={totalPages}
                                    setPage={(newPage) => {
                                        setSearchQuery((prevQuery) => ({
                                            ...prevQuery,
                                            page: newPage,
                                        }));
                                    }}
                                    page={page} // Add 1 to page state to show correct page number
                                    nextPage={nextPage} // Pass the next page number to the Pagination component
                                />
                            </Col>
                        </Row>
                    ) : (
                        ""
                    )}
                </div>
            )}

            <Modal dialogClassName="modal-custom-sm" centered show={block} onHide={blockClose}>
                <Modal.Body className="p-0">
                    <div className="card logout-card common_box">
                        <div className="card-body common_box_body py-4 px-3">
                            <p className="modalTitle text-center mb-2 fw-bold">
                                Are you sure you want to {/* Display appropriate action based on the current state */}
                                {status !== 1 ? "block " : "unblock "}
                                this organiser?
                            </p>
                            <form className="custom_form">
                                <div className="btn-wrapper text-center">
                                    <Link className="btn btn-form btn-cancel" onClick={blockClose}>
                                        No
                                    </Link>
                                    <Link className="btn btn-form btn-add" onClick={() => handleBlockUser()}>
                                        Yes
                                    </Link>
                                </div>
                            </form>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default ApproveOrganizerManagement;
